/* eslint-disable no-undef */
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

import store from './core/store'
import {Provider} from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import {createMuiTheme, MuiThemeProvider, colors} from '@material-ui/core'

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

const theme = createMuiTheme({
    palette: {
        primary: {light: colors.green[300], main: colors.green[500], dark: colors.green[700]},
        secondary: {light: colors.red[300], main: colors.red[500], dark: colors.red[700]}
    }
});

export const baseUrl = '/'
export const titlePrefix = 'Poyser - '

ReactDOM.render(
    <Provider store={store}>
        <Router basename={baseUrl}>
            <MuiThemeProvider theme={theme}>
                <App />
            </MuiThemeProvider>
        </Router>
    </Provider>
    , document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
